import { render, staticRenderFns } from "./login-student.vue?vue&type=template&id=7a6ada0e&scoped=true&"
import script from "./login-student.vue?vue&type=script&lang=js&"
export * from "./login-student.vue?vue&type=script&lang=js&"
import style0 from "./login-student.vue?vue&type=style&index=0&id=7a6ada0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6ada0e",
  null
  
)

export default component.exports